<template>
    <div class="h-[100svh] w-screen">
        <TransitionFade mode="out-in">
            <slot />
        </TransitionFade>
        <div class="fixed top-1/2 right-5 flex flex-col items-center gap-5 -translate-y-1/2 select-none">
            <AtomIconButton icon="add" @click="handlePlus"/>
            <AtomIconButton icon="remove" @click="handleMinus"/>
        </div>
        <OrganismBottomToggle />
    </div>
</template>

<script>

import OrganismBottomToggle from "../components/anarchive/organisms/OrganismBottomToggle.vue";
import AtomIconButton from "../components/global/atoms/AtomIconButton.vue";
import TransitionFade from "../transitions/TransitionFade.vue";

export default {
    name: 'LayoutAnarchive',
    components: {TransitionFade, AtomIconButton, OrganismBottomToggle},
    methods: {
        handlePlus() {
            this.$emit('plus')
        },
        handleMinus() {
            this.$emit('minus')
        }
    }
}
</script>
